import type { Comp, GameObj, PosComp, ZComp } from "kaplay";

export function depth(): Comp {
    return {
        id: "depth",
        require: ["pos", "z"],
        update(this: GameObj<PosComp | ZComp>) {
            this.z = this.pos.y;
        },
    };
}
